export const MIN_HEIGHT_FOR_DESKTOP_NAV = 550;
